import { useEffect, useState } from "react";
import api from "../../../api";
import { toast } from "sonner";

export function useSettings() {
  const [s, setS] = useState(null);
  useEffect(() => {
    api.get("/settings").then((r) =>
      setS({ ...r.data, addon_catalog: (r.data.addon_catalog || []).map((a) => ({ ...a, _k: crypto.randomUUID() })) }));
  }, []);
  const save = async (patch) => {
    try { const r = await api.patch("/settings", patch); setS(r.data); toast.success("Saved"); }
    catch (e) { toast.error(e?.response?.data?.detail || "Could not save"); }
  };
  return { s, setS, save };
}
